<template>
    <div>
        <el-row>
            <el-col>
                <el-card shadow="never">
                    <h1 style="margin-top:unset;">Notify Courier - FLASH</h1>
                    <!-- tab Body Zone -->
                    <el-row>
                        <el-col>
                             <el-tabs type="card">
                                <el-tab-pane label="เรียกรถเข้ารับสินค้า">
                                    <CallNotifyCourierTab />
                                </el-tab-pane>
                                <el-tab-pane label="สถานะรถเข้ารับสินค้า">
                                    <CancelCourierNotifyTab />
                                </el-tab-pane>
                            </el-tabs>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import CallNotifyCourierTab from '@/views/Courier/NotifyFlash/CallNotifyCourierTab.vue'
import CancelCourierNotifyTab from '@/views/Courier/NotifyFlash/CancelCourierNotifyTab.vue'

export default {
    name: 'CourierNotifyFlash',
    components: {
        CallNotifyCourierTab,
        CancelCourierNotifyTab
    }
}
</script>

<style lang="scss">
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
}
.el-transfer-panel{
    width: 300px;
    height:400px;
}
.el-transfer-panel__list.is-filterable{
    height:300px;
    font-size:16px;
    text-align: left;
}
</style>
